// The shared Contract Status Code list (DE 846) — used by CON03 across
// transaction sets. Union of the 844's original CON03 codes and the 845's
// additional ones, per
// reference/session/845-price-authorization-acknowledgment-status-qualifiers-txt.md.
// The home for this DE going forward: a future transaction set's CON03
// should extend this list rather than defining its own.

import type {CodeListEntry} from './types';

export const CONTRACT_STATUS_CODES: CodeListEntry[] = [
  {code: 'OC', label: 'Original Contract'},
  {code: 'VA', label: 'Valid Open Contract'},
  {code: 'SC', label: 'Standard Contract'},
  {code: 'CM', label: 'Contract Modified'},
  {code: 'CR', label: 'Contract Renewed'},
  {code: 'CC', label: 'Contract Cancelled'},
  {code: 'EX', label: 'Expired Contract'},
  {code: 'CA', label: 'Contract Award'},
  {code: 'DL', label: 'Deleted Contract'},
  {code: 'PR', label: 'Proposed Contract'},
  {code: 'PB', label: 'Pending'},
  {code: 'HO', label: 'Hold'},
];
